import React from 'react'
import { router } from '@inertiajs/react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'

export default function Index({ account, accounts, navigation, facilities, params = {} }) {
  const handleDelete = useDeleteWithConfirmation('/manage/facilities')

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value, item) => (
        <div className="flex items-center">
          {item.header_image_url && (
            <img
              src={item.header_image_url}
              alt={item.name}
              className="h-10 w-10 rounded-lg object-cover mr-3"
            />
          )}
          <div>
            <div className="font-medium text-gray-900">{value}</div>
            {item.description && (
              <div className="text-sm text-gray-500 truncate max-w-md">{item.description}</div>
            )}
          </div>
        </div>
      )
    }
  ]

  return (
    <Layout account={account} accounts={accounts} navigation={navigation} title="Facilities">
      <ResourceIndexHeader
        count={facilities.length}
        singular="facility"
        plural="facilities"
        addHref="/manage/facilities/new"
        addLabel="Add Facility"
      />

      <DataTable
        data={facilities}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/facilities/${item.id}/edit`}>Edit</Button>
            <Button link variant="danger" onClick={() => handleDelete(item)}>Delete</Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search facilities..."
        emptyState={{
          message: 'No facilities yet',
          action: { label: 'Create your first facility', href: '/manage/facilities/new' }
        }}
        baseUrl="/manage/facilities"
        params={params}
      />
    </Layout>
  )
}
